module.exports = __webpack_public_path__ + "img/iso.5b153996.svg";